import { type SVGProps } from 'react';

export const Facebook = ({ className }: SVGProps<SVGSVGElement>) => {
  return (
    <svg className={className} height="20" viewBox="0 0 9 18" width="20">
      <path d="M7.96417 8.98266H5.5028V18H1.77361V8.98266H0V5.81361H1.77361V3.76288C1.77361 2.29638 2.47022 0 5.536 0L8.29834 0.0115567V3.08766H6.29408C5.96532 3.08766 5.50305 3.25192 5.50305 3.95148V5.81656H8.28998L7.96417 8.98266Z" />
    </svg>
  );
};
